import { type SearchSettings, useSearchkitClient } from "@/hooks/use-searchkit-client";

// Hoisted so `useSearchkitClient`'s memo deps stay reference-stable across
// renders. Per-page Searchkit config never depends on hook state.
const SEARCH_SETTINGS: SearchSettings = {
  // Target Searchkick's `.word_middle` subfield — it indexes every substring
  // of every word for typo/prefix-friendly matching.
  search_attributes: [{ field: "title.word_middle", weight: 3 }, "tagline.word_middle", "description.word_middle"],
  result_attributes: [
    "type",
    "sqid",
    "title",
    "tagline",
    "description",
    "price_cents",
    "price_currency",
    "free",
    "average_score",
    "reviews_count",
    "cover_image",
    "photos",
    "seller_display_name",
    "seller_handle",
    "seller_initial",
    "seller_profile_type",
    "seller_avatar",
  ],
  highlight_attributes: [],
  facet_attributes: [
    { attribute: "type", field: "type", type: "string" },
    { attribute: "price_cents", field: "price_cents", type: "numeric" },
  ],
  sorting: {
    default: { field: "_score", order: "desc" },
    _price_asc: { field: "price_cents", order: "asc" },
    _price_desc: { field: "price_cents", order: "desc" },
    _top_reviewed: { field: "average_score", order: "desc" },
    _newest: { field: "created_at", order: "desc" },
  },
};

export function useMarketplaceSearch() {
  return useSearchkitClient({
    host: "/api/marketplace",
    indexName: "listings",
    searchSettings: SEARCH_SETTINGS,
    sessionKey: "marketplace",
  });
}
